import { RichText } from '@seek/cmsu-rich-text';
import { Stack, Strong, Text, TextLink } from 'braid-design-system';
import type { ComponentProps } from 'react';

import type { HygraphRichTextContent } from 'src/modules/ApiClient/cms/queries/getRichText';

type TextProps = ComponentProps<typeof Text>;

interface Props {
  richTextData: HygraphRichTextContent;
  textProps?: TextProps;
}

const HygraphRichText = ({ richTextData, textProps }: Props) => (
  <RichText
    wrapper={({ children }) => <Stack space="small">{children}</Stack>}
    content={richTextData?.raw}
    references={richTextData?.references}
    renderers={{
      embed: {
        EmbedSingleLineText: ({ value, bold }) =>
          bold ? <Strong>{value}</Strong> : <span>{value}</span>,
      },
      link: {
        EmbedSingleLineText: ({ value, children }) => (
          <TextLink href={value}>{children}</TextLink>
        ),
      },
      p: ({ children }) => <Text {...textProps}>{children}</Text>,
    }}
  />
);

export default HygraphRichText;
